exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drop-zone[data-v-47a53617]{border:2px dashed #61b7e4;border-radius:10px;background:#f0f6fb;padding:40px 20px;text-align:center;cursor:pointer;transition:border-color .2s,background .2s}.drop-zone[data-v-47a53617]:hover{border-color:#252c5f;background:#e6eef8}.drop-zone-icon[data-v-47a53617]{font-size:48px;color:#252c5f;display:block;margin-bottom:8px}.drop-zone-title[data-v-47a53617]{font-size:15px;font-weight:600;color:#252c5f;margin-bottom:4px}.drop-zone-subtitle[data-v-47a53617]{font-size:12px;color:#8a92a6;margin-bottom:0}", ""]);

// exports
